/*
 * Proprietary and Confidential
 *
 * Copyright (c) [2018] -  [] Marcelo H. Krebber - Munich, London 2018
 * All Rights Reserved.
 *
 * Dissemination or reproduction of this file [home-navigation.js] or parts within
 * via any medium is strictly forbidden unless prior written permission is obtained
 * from <marcelo.krebber@gmail.com>
 *
 * Last modified: 10.03.20, 15:07
 */
import React, {useState} from 'react';

import {WavesTooltipBounded, WavesTooltipLink,} from "../../navigation/buttons/nav-buttons";
import UserInformation from "../information/user-information";
import HomeUserNavigation from "./home-user-navigation";
import {useIsMobile, useLanguage} from "../../configuration/configuration";
import {useAuthorization, useHomeData} from "../../../selectors";
import HomeActionNavigation from "./home-action-navigation";
import {NavigationGroup, NavigationRow} from "../../navigation/layout/nav-layout";
import {PhotoCamera, Settings} from "@material-ui/icons";
import {HomeUserIcon, InfoIconOld} from "../../navigation/icons/nav-icons";
import MobileGalleries from "./mobile-galleries";
import {cn} from "../../util/text-utils";

const HomeNavigation = ({username, location, onUpload = null, type = null, className=null, rounded=false}) => {
        const [showInformation, setOnShowInformation] = useState(false);
        const [showSecondaryMenu, setOnShowSecondaryMenu] = useState(false);
        const {homedata, userdata, user, space, isOwner} = useHomeData();
        const {isAuthorized, isSuperUser} = useAuthorization();
        const isMobile = useIsMobile();
        const Lang = useLanguage();

        const isHomeLocation = location.pathname === `/${username}/home`;
        const isFriendsLocation = location.pathname === `/${username}/friends`;
        const isPendingLocation = location.pathname === `/${username}/pending`;
        const isCalendarLocation = `/${username}/calendar`;

        const onShowInformation = (event) => {
            setOnShowInformation(!showInformation);
        }

        const onShowSecondaryMenu = (event) => {
            setOnShowSecondaryMenu(!showSecondaryMenu);
        }

        const getHeadlineSuffix = (type) => {
            const suffix = isFriendsLocation ? Lang.user.nav.suffix.friends
                : isPendingLocation ? Lang.user.nav.suffix.pending
                    : isCalendarLocation && type === 'spaces' ? Lang.user.nav.suffix.calendar
                        : isCalendarLocation && type === 'events' ? Lang.user.nav.suffix.events : null;

            return suffix ? <React.Fragment>
                    <span className='generic-navigation-headline-title'>| {suffix}</span>
                </React.Fragment> :
                null;
        }

        if (!homedata || !space) return null;

        return <div className={cn('generic-navigation-container home-navigation', [className])}>
            <NavigationRow className={cn('generic-navigation-headline', [rounded, 'rounded'])}>
                {!isHomeLocation && <NavigationGroup>
                    <WavesTooltipLink btn flex
                                      title={Lang.generic.nav.userHome(space.user.firstname)}
                                      className='btn-outline-light generic-navigation-button'
                                      to={`/${username}/home`}>
                        <HomeUserIcon className="mr-1"/>
                        <span>{space.user.firstname}</span>
                    </WavesTooltipLink>

                    {getHeadlineSuffix(type)}

                </NavigationGroup>}

                {isHomeLocation && <NavigationGroup/>}

                <NavigationGroup>
                    <HomeUserNavigation homedata={homedata} username={username}/>

                    {/*show infos even if not authorized*/}
                    <WavesTooltipBounded circle btn primary flex
                                         title={Lang.generic.nav.infos.tooltip}
                                         className='generic-navigation-button mr-2' onClick={onShowInformation}>
                        <InfoIconOld fontSize='small' className="clr-white" aria-hidden="true"/>
                    </WavesTooltipBounded>

                    {/*upload*/}
                    {isAuthorized && onUpload && (isOwner || isSuperUser) &&
                        <WavesTooltipBounded circle btn primary flex
                                             title={Lang.user.nav.uploadCover}
                                             className='generic-navigation-button mr-2' onClick={onUpload}>
                            <PhotoCamera fontSize='small' className="clr-white" aria-hidden="true"/>
                        </WavesTooltipBounded>}

                    {/*open menu*/}
                    {isAuthorized && (isOwner || isSuperUser) &&
                        <WavesTooltipBounded circle btn primary flex
                                             title={Lang.generic.nav.manageUser.tooltip}
                                             className='generic-navigation-button mr-2' onClick={onShowSecondaryMenu}>
                            <Settings fontSize='small' className="clr-white" aria-hidden="true"/>
                        </WavesTooltipBounded>}

                </NavigationGroup>
            </NavigationRow>

            {isAuthorized && showSecondaryMenu &&
                <HomeActionNavigation
                    accessRoles={{
                        isAuthorized: isAuthorized,
                        isOwner: isOwner,
                        isSuperUser: isSuperUser,
                    }}
                    accessUrls={
                        {editUrl: '/update/account'}
                    }/>
            }

            {showInformation && !isFriendsLocation && !isPendingLocation &&
                <UserInformation className='generic-navigation-body'
                                 user={user}
                                 userdata={userdata}
                                 space={space}
                                 isOwner={isOwner}/>}

            {isMobile && username && <MobileGalleries username={username}/>}

        </div>
    }
;

export default HomeNavigation;